export const getEntryTypeOptions = (t) => [
	{ value: 'birth', label: t('admin.animal.entry_birth') },
	{ value: 'buy', label: t('admin.animal.entry_buy') },
	{ value: 'census', label: t('admin.animal.entry_census') }
]